<div *ngIf="performance" class="performance-summary">

    <div class="performance-summary-tile">

        <div class="badge-top-position">
            <div class="badge top-right"
                 [ngClass]="getKpiStatusClass(performance.metricModel?.feedingStatus)">
                {{ getKpiStatusLabel(performance.metricModel?.feedingStatus) }}
            </div>
        </div>

        <div class="tile-header">
            <span>Current Feeding Consumption</span>
            <div class="value">
                {{ performance.metricModel?.currentFeedingConsumption }}
            </div>
        </div>

        <div *ngIf="getTopInsight('feed') as insight" class="insight">

            <div class="badge"
                 [ngClass]="getSeverityClass(insight.severity)">
                {{ getSeverityLabel(insight.severity) }}
            </div>

            <div class="title">{{ insight.title }}</div>
            <div class="body">{{ insight.body }}</div>

            <div *ngIf="insight.metric" class="meta">
                {{ insight.metric.value }} {{ insight.metric.unit || '' }}
                <span *ngIf="insight.metric.benchmark">
                    | Benchmark: {{ insight.metric.benchmark }}
                </span>
            </div>

            <div *ngIf="insight.actions?.length" class="actions">
                <div *ngFor="let a of insight.actions">
                    <strong>[{{ a.priority?.toUpperCase() }}]</strong> {{ a.title }}
                </div>
            </div>

        </div>
    </div>

    <div class="performance-summary-tile">

        <div class="badge-top-position">
            <div class="badge top-right"
                 [ngClass]="getKpiStatusClass(performance.metricModel?.averageWeightStatus)">
                {{ getKpiStatusLabel(performance.metricModel?.averageWeightStatus) }}
            </div>
        </div>

        <div class="tile-header">
            <span>Average Weight</span>
            <div class="value">
                {{ performance.metricModel?.averageWeight }}
            </div>
        </div>

        <div class="sub">
            Target: {{ performance.metricModel?.target }} |
            Achieved: {{ performance.metricModel?.averageWeight }}
        </div>

        <div *ngIf="getTopInsight('weight') as insight" class="insight">

            <div class="badge"
                 [ngClass]="getSeverityClass(insight.severity)">
                {{ getSeverityLabel(insight.severity) }}
            </div>

            <div class="title">{{ insight.title }}</div>
            <div class="body">{{ insight.body }}</div>

            <div *ngIf="insight.metric" class="meta">
                {{ insight.metric.value }} {{ insight.metric.unit || '' }}
                <span *ngIf="insight.metric.benchmark">
                    | Benchmark: {{ insight.metric.benchmark }}
                </span>
            </div>

            <div *ngIf="insight.actions?.length" class="actions">
                <div *ngFor="let a of insight.actions">
                    <strong>[{{ a.priority?.toUpperCase() }}]</strong> {{ a.title }}
                </div>
            </div>

        </div>
    </div>


    <div class="performance-summary-tile">

        <div class="badge-top-position">
            <div class="badge top-right"
                 [ngClass]="getKpiStatusClass(performance.mortalityRate?.mortalityRateStatus)">
                {{ getKpiStatusLabel(performance.mortalityRate?.mortalityRateStatus) }}
            </div>
        </div>

        <div class="tile-header">
            <span>Mortality Rate</span>
            <div class="value">
                {{ performance.mortalityRate?.mortalityRate }}%
            </div>
        </div>

        <div class="sub">
            Total Birds: {{ performance.mortalityRate?.totalBirds }} |
            Mortality: {{ performance.mortalityRate?.mortality }}
        </div>

        <div *ngIf="getTopInsight('mortality') as insight" class="insight">

            <div class="badge"
                 [ngClass]="getSeverityClass(insight.severity)">
                {{ getSeverityLabel(insight.severity) }}
            </div>

            <div class="title">{{ insight.title }}</div>
            <div class="body">{{ insight.body }}</div>

            <div *ngIf="insight.metric" class="meta">
                {{ insight.metric.value }} {{ insight.metric.unit || '' }}
                <span *ngIf="insight.metric.benchmark">
                    | Benchmark: {{ insight.metric.benchmark }}
                </span>
            </div>

            <div *ngIf="insight.actions?.length" class="actions">
                <div *ngFor="let a of insight.actions">
                    <strong>[{{ a.priority?.toUpperCase() }}]</strong> {{ a.title }}
                </div>
            </div>

        </div>
    </div>

</div>